<style scoped>
.white::after {
  border: 0.1rem solid #fff;
  border-right-color: transparent;
  border-top-color: transparent;
}
span {
  margin: 2em 0
}
</style>

<template>
  <div key="1" v-if="!loaded" class="loading" :class="`loading-${size || 'sm'} ${color}` "></div>
</template>

<script>
export default {
  props: ['loaded', 'size', 'color'],
  computed: {
    getColor () {
      if (this.color) {
        return `border-color: ${this.color}`
      }
      return null
    }
  }
}
</script>
